import React, { useState } from "react";
import { Button, Modal, Upload, message, Input, Spin } from "antd";
import * as Icon from "react-feather";
import { Pagination } from "antd";
import * as XLSX from "xlsx";
import { list_policies, upload_policy } from "services/apiSrv";
import { useQuery } from "react-query";
import Loader from "components/widgets/loader";
import CustomTable from "components/widgets/table";
import { fetchIntermediarypolicies } from "services/apiSrv";
import { useHistory } from "react-router-dom";
import AddPortfolio from "components/widgets/modals/AddPortfolio";
import { formatDate } from "utils/helpers";

// Transform Excel data into objects
function transformData(data) {
  const headers = data[0];
  console.log("headers==", headers);

  return data.slice(1).map((row) =>
    headers.reduce((obj, key, index) => {
      if (key === "startDate") {
        const value = row[index];
        if (typeof value === "number" && value > 0) {
          const excelEpoch = new Date(1899, 11, 30);
          const msPerDay = 24 * 60 * 60 * 1000;
          const date = new Date(excelEpoch.getTime() + value * msPerDay);
          obj[key] = date.toISOString().split("T")[0];
        } else {
          obj[key] = String(value);
        }
      } else {
        obj[key] = row[index];
      }
      return obj;
    }, {})
  );
}

export default function Portfolio() {
  const [current, setCurrent] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [policyRemarks, setPolicyRemarks] = useState("");
  const [isUploading, setIsUploading] = useState(false); // New loading state
  const [showAddPortfolio, setShowAddPortfolio] = useState(false);
  const history = useHistory()

  // Fetch policies using react-query
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["policies"],
    queryFn: fetchIntermediarypolicies,
    retry: 2,
    staleTime: 5 * 60 * 1000,
  });

  console.log("dataa ", data)
  console.log("selectedRow==", selectedRow);
  if (isLoading) return <Loader />;
  if (isError) return <h2>Error fetching policies: {error?.message || "Something went wrong"}</h2>;
  if (!data?.data) return <h2>No policies data available.</h2>;

  const onChange = (page) => setCurrent(page);

  const fields = [
    "Product Name",
    "Policy Number",
    "Insurance Class",
    "Underwriter",
    "Start Date",
    "End Date",
    "Amount",
    "Client Name",
    "Phone Number",
    "Email Address",
    "ID Number",
    "Registration Number",
    "Asset Value",
    "Car Make",
    "Model",
    "Payment Date",
    "Payment Amount",
    "Payment Reference",
  ];

  const modalStyles = `
    .portfolio-modal .ant-modal-content,
    .upload-modal .ant-modal-content {
      border-radius: 16px;
      overflow: hidden;
    }
    
    .portfolio-modal .ant-modal-body,
    .upload-modal .ant-modal-body {
      background-color: #f8fafc;
      border-radius: 16px;
      padding: 0;
      max-height: 70vh;
      overflow-y: auto;
    }
    
    .modal-header {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 4px;
    }
    
    .modal-icon-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      background: linear-gradient(135deg, #3b82f6, #2563eb);
      border-radius: 12px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    }
    
    .modal-content {
      padding: 24px;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
    
    .product-header {
      text-align: center;
      background: linear-gradient(135deg, #eff6ff, #e0e7ff);
      padding: 24px;
      border-radius: 16px;
      border: 1px solid #dbeafe;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    
    .product-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 64px;
      background: linear-gradient(135deg, #3b82f6, #4338ca);
      border-radius: 16px;
      margin-bottom: 16px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    }
    
    .status-badge {
      display: inline-flex;
      align-items: center;
      padding: 8px 16px;
      background: white;
      border-radius: 9999px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      border: 1px solid #dbeafe;
    }
    
    .status-indicator {
      width: 8px;
      height: 8px;
      background-color: #4ade80;
      border-radius: 50%;
      margin-right: 8px;
      animation: pulse 2s infinite;
    }
    
    .info-card {
      background: white;
      border-radius: 16px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      border: 1px solid #e5e7eb;
      overflow: hidden;
    }
    
    .info-card-header {
      background: linear-gradient(135deg, #f9fafb, #f3f4f6);
      padding: 16px 24px;
      border-bottom: 1px solid #e5e7eb;
      display: flex;
      align-items: center;
    }
    
    .info-card-body {
      padding: 24px;
    }
    
    .info-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }
    
    .info-grid.single-column {
      grid-template-columns: 1fr;
    }
    
    .info-item {
      display: flex;
      flex-direction: column;
    }
    
    .info-label {
      font-size: 12px;
      font-weight: 600;
      color: #6b7280;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-bottom: 8px;
    }
    
    .info-value-container {
      display: flex;
      align-items: center;
    }
    
    .info-icon {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
    }
    
    .info-icon.blue { background-color: #dbeafe; }
    .info-icon.green { background-color: #dcfce7; }
    .info-icon.purple { background-color: #e9d5ff; }
    .info-icon.orange { background-color: #fed7aa; }
    .info-icon.red { background-color: #fecaca; }
    .info-icon.yellow { background-color: #fef3c7; }
    
    .premium-card {
      background: linear-gradient(135deg, #f0fdf4, #ecfdf5);
      border-radius: 16px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      border: 1px solid #bbf7d0;
      overflow: hidden;
    }
    
    .premium-header {
      background: linear-gradient(135deg, #dcfce7, #bbf7d0);
      padding: 16px 24px;
      border-bottom: 1px solid #bbf7d0;
      display: flex;
      align-items: center;
    }
    
    .premium-body {
      padding: 24px;
      text-align: center;
    }
    
    .premium-icon-large {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 80px;
      background: linear-gradient(135deg, #22c55e, #059669);
      border-radius: 16px;
      margin-bottom: 16px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    }
    
    .premium-amount {
      font-size: 2.5rem;
      font-weight: bold;
      color: #047857;
      margin-bottom: 8px;
    }
    
    .custom-button {
      height: 48px;
      padding: 0 32px;
      font-weight: 600;
      border-radius: 12px;
      transition: all 0.2s;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    
    .custom-button:hover {
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
      transform: translateY(-1px);
    }
    
    .custom-button.cancel {
      background: white;
      border: 2px solid #d1d5db;
      color: #374151;
    }
    
    .custom-button.cancel:hover {
      border-color: #9ca3af;
      background-color: #f9fafb;
    }
    
    .custom-button.primary {
      background: linear-gradient(135deg, #2563eb, #1d4ed8);
      border: none;
      color: white;
    }
    
    .custom-button.primary:hover {
      background: linear-gradient(135deg, #1d4ed8, #1e40af);
    }
    
    .custom-button.upload {
      background: linear-gradient(135deg, #10b981, #059669);
      border: none;
      color: white;
    }
    
    .custom-button.upload:hover {
      background: linear-gradient(135deg, #059669, #047857);
    }
    
    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
  `;

  const showModal = (row) => {
    console.log("Selected row ID:", row); // Debug the row (policySystemRef string)
    
    // Find the policy object in data?.data[0]?.items that matches the policySystemRef
    const selectedPolicy = data?.data[0]?.items?.find(
      (item) => item.policySystemRef === row
    );
    
    console.log("Selected policy object:", selectedPolicy); // Debug the found object
    
    // Set the found policy object as selectedRow, or null if not found
    setSelectedRow(selectedPolicy || null);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedRow(null);
  };

  const showUploadModal = () => setIsUploadModalVisible(true);

  const handleUploadCancel = () => {
    if (!isUploading) {
      setIsUploadModalVisible(false);
      setFileList([]);
      setPolicyRemarks("");
    }
  };

  const handleUpload = async () => {
    if (fileList.length === 0) {
      message.error("Please select a file to upload.");
      return;
    }

    setIsUploading(true); // Set loading state to true

    const file = fileList[0];
    const reader = new FileReader();

    //     const worksheetData = XLSX.utils.sheet_to_json(worksheet, {
    //     raw: false, // Ensures dates are not returned as raw numbers
    //     dateNF: "yyyy-mm-dd" // Specifies the desired date format
    // });

    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: false, dateNF: "yyyy-mm-dd" });
        const rowData = transformData(jsonData);
        console.log("ROWDATA===", rowData);

        // Filter out empty rows
        const nonEmptyRows = rowData.filter((row) => {
          if (typeof row !== "object" || row === null || row === undefined) return false;

          const fieldsToCheck = Object.keys(row).filter(
            (key) =>
              ![
                "CoverType",
                "endDate",
                "startDate",
                "policyNumber",
                "basePremium",
                "email",
                "phone",
                "kraPin",
                "firstName",
                "lastName",
                "riskValue",
                "riskRef",
                "riskchassisNumber",
                "riskMake",
                "riskModel",
                "policyCurrency",
                "commisionEarned",
                "insuranceClass",
                "productName",
              ].includes(key)
          );

          return fieldsToCheck.some((key) => {
            const value = row[key];
            if (value === null || value === undefined) return false;
            if (typeof value === "string") {
              const trimmedValue = value.trim();
              return trimmedValue !== "" && trimmedValue !== "\u200B";
            }
            return true;
          });
        });
        console.log("NONWEMPTYROWDATA===", nonEmptyRows);
      
        for (let row of nonEmptyRows) {  
          const coverType = row.CoverType
      ? row.CoverType.split(' - ')[0].trim().toUpperCase()
      : '';
      const InsuranceClass= row.insuranceClass?row.insuranceClass.split('-')[0].trim() :""
          row.externalProductRef = "";
          row.policyExternalRef = "";
          row.underwriterInternalRef = "";
          row.riskValue =Number(row.riskValue)

          row.basePremium = Number(row.basePremium)
          row.additionalPremium = Number(row.additionalPremium)
          row.totalCharges = Number(row.totalCharges)
          row.value = Number(row.value)
          row.totalDiscount = Number(row.totalDiscount)
          row.commisionEarned = Number(row.commisionEarned)
          row.CoverType=coverType
          row.insuranceClass=InsuranceClass
          

          console.log("Row==", row)

          const res=await upload_policy(row, policyRemarks);
          return res
        }
        message.success("Excel file uploaded successfully!");
        refetch() //refetcges policies

        setIsUploadModalVisible(false);
        setFileList([]);
        setPolicyRemarks("");
      } catch (error) {
        message.error("Error processing Excel file: " + error.message);
      } finally {
        setIsUploading(false); // Reset loading state
      }
    };

    reader.onerror = () => {
      message.error("Error reading the file.");
      setIsUploading(false); // Reset loading state on error
    };
    reader.readAsArrayBuffer(file);
  };

  const uploadProps = {
    onRemove: (file) => setFileList((prev) => prev.filter((item) => item.uid !== file.uid)),
    beforeUpload: (file) => {
      const isExcel =
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      if (!isExcel) {
        message.error("You can only upload Excel files!");
        return false;
      }
      setFileList([file]);
      return false;
    },
    fileList,
    accept: ".xlsx,.xls",
  };

  const tableData = {
    icon: "https://api.prod.nexus.ke/static/2e259176-69d3-4abe-adc5-690a3722141e.webp",
    title: "Quotation Details",
    table_fields: [
      { name: "Policy Number", align: "c" },
      { name: "First Name", align: "c" },
      { name: "Middle Name", align: "c" },
      { name: "Last Name", align: "c" },
      { name: "Remarks", align: "c" },
      { name: "Insurance Type", align: "c" },
      { name: "Product Status", align: "c" },
      { name: "Start Date", align: "c" },
      { name: "End Date", align: "c" },
      { name: "Currency", align: "c" },
      { name: "Premium", align: "c" },
      { name: "Action", align: "c" },
    ],
    search_fields: ["question_code", "answer"],
    row_data: [
      {
        type: "text",
        field: "policyNumber",
        class: "center",
      },
      {
        type: "text",
        field: "client.names.firstName",
        class: "center",
      },
        {
        type: "text",
        field: "client.names.middleName",
        class: "center",
      },
        {
        type: "text",
        field: "client.names.lastName",
        class: "center",
      },
      {
        type: "text",
        field: "policyRemarks",
        class: "center",
      },
      {
        type: "text",
        field: "policyType",
        class: "center",
      },
      {
        type: "status",
        field: "policyStatus",
        class: "center",
        value: "INACTIVE",
      },
      {
        type: "date",
        field: "policyCover.startDate",
        class: "center",
        // value: "2026-09-14",
      },
      {
        type: "date",
        field: "policyCover.endDate",
        class: "center",
        // value: "2026-09-14",
      },
      {
        type: "currency",
        field: "quotationCurrency",
        class: "center",
        currency: "KES",
      },
      {
        type: "text",
        field: "quotationPremium.totalPremium",
        class: "center",
        currency: "KES",
      },
      {
        type: "action",
        field: "name",
        class: "center",
        icon: "",
        value: "Linet Mwangi",
        actions: [
          {
            type: "menu",
            title: "View",
            field: "policySystemRef",
            method: (row) => {
              console.log("Row data:", row); // Debug row data
              // showModal(row);
              history.push(`/dashboard/portfolio/${row}`)
            },
          },
        ],
      },
    ],
  };

  const handleSinglePolicyUpload = async (data) => {
    try {
     const res=  await upload_policy(data, "_");
     console.log("single upload res", res)
    } catch (error) {
       console.log("single upload res error", error)
    }
  }
  return (
    <>
      <div className="pageheader pd-t-25 pd-b-35 py-8">
        <div className="breadcrumb pd-0 mg-0">
          <a className="breadcrumb-item" href="index.html">
            <i className="icon ion-ios-home-outline" /> Home
          </a>
          <a className="breadcrumb-item active" href>
            Pricing
          </a>
        </div>
      </div>
      <div className="col-lg-12 col-xl-12" style={
        { borderRadius: "12PX", background: "#ffffff",   padding:"2rem"}
      }>

<div className="my-4 d-flex flex-column flex-md-row gap-3 align-items-md-center">
  <div className="d-flex flex-column flex-sm-row">
    <a
      onClick={showUploadModal}
      style={{
        textDecoration: "none",
        padding: "10px 16px",
        backgroundColor: "#28a745",
        color: "#fff",
        borderRadius: "29px",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <Icon.Upload size={13} style={{ marginRight: "8px" }} />
      Upload Excel
    </a>
    
    <a
      className="ms-sm-0 ms-md-2"
      onClick={() => setShowAddPortfolio(true)}
      style={{
        textDecoration: "none",
        padding: "10px 16px",
        backgroundColor: "#2563eb",
        color: "#fff",
        borderRadius: "29px",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <Icon.PlusSquare size={13} style={{ marginRight: "8px" }} />
      Add Portfolio
    </a>
  </div>
  
  <div className="mt-2 mt-md-0 ml-md-auto">
    <a
      href="/templates/policies.xlsx"
      download="template.xlsx"
      style={{
        textDecoration: "none",
        padding: "10px 16px",
        backgroundColor: "#28a745",
        color: "#fff",
        borderRadius: "29px",
        display: "block",
      }}
    >
      Download Template
    </a>
  </div>
</div>
        <CustomTable
          table_fields={tableData.table_fields}
          row_data={tableData.row_data}
          table_data={data?.data}
          title={tableData.title}
        />
      </div>
      <Modal
        title={
          <div className="modal-header">
            <div className="modal-icon-container">
              <Icon.Eye size={24} style={{ color: "white" }} />
            </div>
            <div>
              <h3 style={{ fontSize: "20px", fontWeight: "bold", color: "#1f2937", margin: 0 }}>
                Policy Details
              </h3>
            </div>
          </div>
        }
        open={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel} className="custom-button cancel">
            <Icon.X size={18} style={{ marginRight: "8px" }} />
            Close
          </Button>,
        ]}
        width={700}
        centered
        className="portfolio-modal"
        maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.6)", backdropFilter: "blur(4px)" }}
      >
        <style>{modalStyles}</style>
        {selectedRow && typeof selectedRow === "object" ? (
          <div className="modal-content">
            {/* Policies Section */}
            <div className="info-card">
              <div className="info-card-header">
                <Icon.FileText size={20} style={{ color: "#2563eb", marginRight: "12px" }} />
                <h3 style={{ fontSize: "18px", fontWeight: "bold", color: "#1f2937", margin: 0 }}>
                  Policies
                </h3>
              </div>
              <div className="info-card-body">
                <div className="info-grid">
                  <div className="info-item">
                    <p className="info-label">Product Name</p>
                    <div className="info-value-container">
                      <div className="info-icon blue">
                        <Icon.Shield size={14} style={{ color: "#2563eb" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.productSystemRef || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Policy Number</p>
                    <div className="info-value-container">
                      <div className="info-icon blue">
                        <Icon.Hash size={14} style={{ color: "#2563eb" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.policyNumber || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Insurance Class</p>
                    <div className="info-value-container">
                      <div className="info-icon purple">
                        <Icon.Briefcase size={14} style={{ color: "#7c3aed" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.insuranceClassRef || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Underwriter</p>
                    <div className="info-value-container">
                      <div className="info-icon orange">
                        <Icon.Home size={14} style={{ color: "#ea580c" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.underwriterSystemRef || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Start Date</p>
                    <div className="info-value-container">
                      <div className="info-icon green">
                        <Icon.Calendar size={14} style={{ color: "#059669" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {formatDate(selectedRow.policyCover?.startDate) || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">End Date</p>
                    <div className="info-value-container">
                      <div className="info-icon green">
                        <Icon.Calendar size={14} style={{ color: "#059669" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.policyCover?.endDate || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Amount</p>
                    <div className="info-value-container">
                      <div className="info-icon yellow">
                        <Icon.Briefcase size={14} style={{ color: "#d97706" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.quotationPremium?.totalPremium ? `${selectedRow.quotationPremium.totalPremium} ${selectedRow.quotationCurrency || ''}` : "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Client Information */}
            <div className="info-card">
              <div className="info-card-header">
                <Icon.User size={20} style={{ color: "#2563eb", marginRight: "12px" }} />
                <h3 style={{ fontSize: "18px", fontWeight: "bold", color: "#1f2937", margin: 0 }}>
                  Client Information
                </h3>
              </div>
              <div className="info-card-body">
                <div className="info-grid">
                  <div className="info-item">
                    <p className="info-label">Client Name</p>
                    <div className="info-value-container">
                      <div className="info-icon blue">
                        <Icon.User size={14} style={{ color: "#2563eb" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.clientDetails?.name || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Phone Number</p>
                    <div className="info-value-container">
                      <div className="info-icon green">
                        <Icon.Phone size={14} style={{ color: "#059669" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.clientDetails?.phone || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Email Address</p>
                    <div className="info-value-container">
                      <div className="info-icon red">
                        <Icon.Mail size={14} style={{ color: "#dc2626" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.clientDetails?.email || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">ID Number</p>
                    <div className="info-value-container">
                      <div className="info-icon yellow">
                        <Icon.CreditCard size={14} style={{ color: "#d97706" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.clientDetails?.idNumber || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Risks Section */}
            <div className="info-card">
              <div className="info-card-header">
                <Icon.AlertTriangle size={20} style={{ color: "#2563eb", marginRight: "12px" }} />
                <h3 style={{ fontSize: "18px", fontWeight: "bold", color: "#1f2937", margin: 0 }}>
                  Risks
                </h3>
              </div>
              <div className="info-card-body">
                <div className="info-grid">
                  <div className="info-item">
                    <p className="info-label">Registration Number</p>
                    <div className="info-value-container">
                      <div className="info-icon blue">
                        <Icon.Hash size={14} style={{ color: "#2563eb" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.risks?.[0]?.riskRef || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Asset Value</p>
                    <div className="info-value-container">
                      <div className="info-icon green">
                        <Icon.Briefcase size={14} style={{ color: "#059669" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.risks?.[0]?.value ? `${selectedRow.risks[0].value} ${selectedRow.quotationCurrency || ''}` : "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Car Make</p>
                    <div className="info-value-container">
                      <div className="info-icon purple">
                        <Icon.Truck size={14} style={{ color: "#7c3aed" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.risks?.[0]?.details?.make || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Model</p>
                    <div className="info-value-container">
                      <div className="info-icon orange">
                        <Icon.Truck size={14} style={{ color: "#ea580c" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.risks?.[0]?.details?.model || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Payment Information */}
            <div className="info-card">
              <div className="info-card-header">
                <Icon.CreditCard size={20} style={{ color: "#2563eb", marginRight: "12px" }} />
                <h3 style={{ fontSize: "18px", fontWeight: "bold", color: "#1f2937", margin: 0 }}>
                  Payment Information
                </h3>
              </div>
              <div className="info-card-body">
                <div className="info-grid">
                  <div className="info-item">
                    <p className="info-label">Payment Date</p>
                    <div className="info-value-container">
                      <div className="info-icon blue">
                        <Icon.Calendar size={14} style={{ color: "#2563eb" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.policyPayment?.nextPaymentDate || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Payment Amount</p>
                    <div className="info-value-container">
                      <div className="info-icon green">
                        <Icon.Briefcase size={14} style={{ color: "#059669" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.policyPayment?.nextPaymentAmount ? `${selectedRow.policyPayment.nextPaymentAmount} ${selectedRow.quotationCurrency || ''}` : "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="info-item">
                    <p className="info-label">Payment Reference</p>
                    <div className="info-value-container">
                      <div className="info-icon red">
                        <Icon.Hash size={14} style={{ color: "#dc2626" }} />
                      </div>
                      <p style={{ fontSize: "16px", fontWeight: "600", color: "#111827", margin: 0 }}>
                        {selectedRow.policyRef || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="modal-content">
            <p style={{ color: "#dc2626", textAlign: "center" }}>
              No valid policy data available.
            </p>
          </div>
        )}
      </Modal>
      <Modal
        title={
          <div className="modal-header">
            <div className="modal-icon-container">
              <Icon.Upload size={24} style={{ color: "white" }} />
            </div>
            <div>
              <h3 style={{ fontSize: "20px", fontWeight: "bold", color: "#1f2937", margin: 0 }}>
                Upload Excel File
              </h3>
            </div>
          </div>
        }
        open={isUploadModalVisible}
        onCancel={handleUploadCancel}
        footer={[
          <Button
            key="cancel"
            onClick={handleUploadCancel}
            className="custom-button cancel"
            disabled={isUploading}
          >
            <Icon.X size={18} style={{ marginRight: "8px" }} />
            Cancel
          </Button>,
          <Button
            key="upload"
            type="primary"
            onClick={handleUpload}
            className="custom-button primary"
            disabled={fileList.length === 0 || isUploading}
          >
            {isUploading ? (
              <Spin size="small" style={{ marginRight: "8px" }} />
            ) : (
              <Icon.Upload size={18} style={{ marginRight: "8px" }} />
            )}
            {isUploading ? "Uploading..." : "Upload"}
          </Button>,
        ]}
        width={500}
        centered
        className="upload-modal"
        maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.6)", backdropFilter: "blur(4px)" }}
        maskClosable={!isUploading}
        closable={!isUploading}
      >
        <style>{modalStyles}</style>
        <div className="modal-content">
          {isUploading ? (
            <div style={{ textAlign: "center", padding: "24px" }}>
              <Loader />
              <p style={{ marginTop: "16px", color: "#6b7280" }}>
                Uploading file, please wait...
              </p>
            </div>
          ) : (
            <>
              <Upload {...uploadProps} maxCount={1}>
                <Button
                  className="custom-button primary"
                  icon={<Icon.Upload size={18} style={{ marginRight: "8px" }} />}
                  disabled={isUploading}
                >
                  Select Excel File
                </Button>
              </Upload>
              <Input
                placeholder="Enter policy remarks"
                value={policyRemarks}
                onChange={(e) => setPolicyRemarks(e.target.value)}
                style={{ marginTop: "16px" }}
                disabled={isUploading}
              />
              <p style={{ marginTop: "16px", color: "#6b7280" }}>
                Please upload an Excel file (.xlsx or .xls) containing portfolio data.
              </p>
            </>
          )}
        </div>
      </Modal>
      {/* AddPortfolio modal (local to this page) */}
      <AddPortfolio show={showAddPortfolio} onHide={() => setShowAddPortfolio(false)} onSubmit={handleSinglePolicyUpload} fetchPortfolios={refetch} />
    </>
  );
}